import { useSelector } from 'react-redux'
import { useCurrentId } from 'hooks/useCurrentId'
import { getModeledProductions } from 'selectors'

export function useProductionByRoute () {
  const currentId = useCurrentId()

  const production = useSelector(getModeledProductions).find(
    item => item.id === currentId
  )
  return production
}

export default useProductionByRoute
